import { Auracast } from '@shure/cloud/shared/models/devices';

import {
	AuracastAudioChannelFeatureFragment,
	AuracastFeatureFragment,
	BluetoothPowerFeatureFragment
} from '../graphql/generated/cloud-sys-api';

import { mapBluetoothPowerFromSysApi } from './map-bluetooth-power';

export type AllAuracastAudioChannelFeatureFragments = {
	channelId: string;
} & AuracastAudioChannelFeatureFragment;

export type AllAuracastDeviceFeatureFragments = AuracastFeatureFragment & BluetoothPowerFeatureFragment;

export function mapAuracastFromSysApi(
	auracastDevice: AllAuracastDeviceFeatureFragments | null,
	auracastAudioChannel?: AllAuracastAudioChannelFeatureFragments | null
): Auracast {
	return {
		available: auracastDevice?.auracast?.available ?? false,
		enabled: auracastAudioChannel?.auracast?.enabled ?? false,
		broadcastName: auracastAudioChannel?.auracast?.name,
		encryptionEnabled: auracastAudioChannel?.auracast?.encryption?.enabled ?? false,
		broadcastCode: auracastAudioChannel?.auracast?.encryption?.passphrase ?? undefined,
		bluetoothPowerLevel: mapBluetoothPowerFromSysApi(auracastDevice?.bluetoothPower?.level),
		channelId: auracastAudioChannel?.channelId
	};
}
